<form novalidate #currentForm="ngForm">
  <div class="setup">
    <div class="section-container">
      <div class="label-data label">Identity</div>
      <div>
        <nrwl-test-identity
          [testName]="testName"
          [customer]="customerName"
          [technician]="technicianName"
          [editMode]="editMode || cloneMode"
          [showCustomerTechnician]="false"
          (updateTestIdentity)="updateTestIdentity($event)"
        ></nrwl-test-identity>
      </div>
    </div>
    <div class="section-container">
      <div class="label-data label"><b>Endpoints</b></div>
      <div class="originator">
        <nrwl-agent-picker
          [testType]="testType"
          [originatorDevice]="selectedOriginator"
          [editMode]="editMode"
          [originatorMultiSelection]="false"
          [testMode]="testMode"
          [showTestMode]="false"
          [selectReflectorDevice]="true"
          (emitAgents)="onAgentChange($event)"
        ></nrwl-agent-picker>
        <div class="error top-8" *ngIf="isLimitExceeded">
          Selected agent exceeds the maximum test limit.
        </div>
        <div class="error top-8" *ngIf="isJmepAgentType && !jmepLicenseEnabled && isLicenseLoaded">
          JMEP TWAMP test license is missing. Please contact VIAVI customer support.
        </div>
      </div>
    </div>
    <div class="section-container" *ngIf="!isJmepAgentType">
      <div class="label-data label"><b>Setup</b></div>
      <div class="column">
        <div
          class="row start center reflect-banner"
          *ngIf="reflectorTypeValid() && reflectorVersionValid()"
        >
          <div class="row">
            <div class="control-group">
              <label for="mode" class="labelMode">Reflector Mode</label>
              <mat-select
                name="mode"
                #modeInput="ngModel"
                [(ngModel)]="formField.reflectorMode"
                class="input-decor input-medium"
                (selectionChange)="onReflectorModeChange($event)"
              >
                <mat-option value="light">TWAMP Light</mat-option>
                <mat-option value="full">TWAMP Full</mat-option>
              </mat-select>
            </div>
            <div class="control-group">
              <label for="ipVersion" class="labelMode">IP Version</label>
              <mat-select
                name="ipVersion"
                #ipversionInput="ngModel"
                [(ngModel)]="formField.ipVersion"
                class="input-decor input-mini"
                [disabled]="!isNewTestConfig || !ipVersionEnabled || mgmtPortTesting"
                (selectionChange)="onChangeVersion($event)"
                matTooltip="This endpoint has management port testing enabled. IP version is set to the
              version of the endpoint."
                [matTooltipDisabled]="!mgmtPortTesting"
              >
                <mat-option value="v4">v4</mat-option>
                <mat-option value="v6">v6</mat-option>
              </mat-select>
            </div>
          </div>
        </div>
        <div class="row row-item" *ngIf="'v6' !== formField.ipVersion">
          <div class="control-group">
            <label class="labelMode">Address *</label>
            <input
              matInput
              autocomplete="off"
              [(ngModel)]="formField.ipAddress"
              name="ip"
              class="control input-decor input-ipv4"
              [disabled]="mgmtPortTesting"
              required
              #addressInput="ngModel"
              [pattern]="ipv4Pattern"
              [ngClass]="{
                invalidInput: (isnotUniqueConfig || isnotUniqueIPConfig) && isNewTestConfig
              }"
              (ngModelChange)="isUniqueConfig(); ipAddressChange()"
              matTooltip="This endpoint has management port testing enabled. IP address is set to the
            address of the endpoint."
              [matTooltipDisabled]="!mgmtPortTesting"
            />
            <div *ngIf="isNewTestConfig" class="err-msgContainer">
              <mat-error *ngIf="addressInput?.errors?.required"> Required field</mat-error>
              <mat-error *ngIf="addressInput?.errors?.pattern">Invalid address</mat-error>
              <mat-error *ngIf="isnotUniqueConfig || isnotUniqueIPConfig"
                >Address in use by running reflector/initiator</mat-error
              >
            </div>
          </div>
          <div class="control-group" *ngIf="!mgmtPortTesting">
            <label class="labelMode">Subnet mask *</label>
            <input
              matInput
              autocomplete="off"
              [(ngModel)]="formField.subnet"
              name="subnet"
              class="control input-decor input-ipv4"
              required
              #subnetInput="ngModel"
              [pattern]="ipv4SubnetPattern"
              (ngModelChange)="subnetChange()"
            />
            <div *ngIf="isNewTestConfig" class="err-msgContainer">
              <mat-error *ngIf="subnetInput?.errors?.required"> Required field</mat-error>
              <mat-error *ngIf="subnetInput.errors?.pattern"> Invalid subnet mask </mat-error>
            </div>
          </div>
          <div class="control-group" *ngIf="!mgmtPortTesting">
            <label class="labelMode">Gateway *</label>
            <input
              matInput
              autocomplete="off"
              [(ngModel)]="formField.gateway"
              name="gateway"
              class="control input-decor input-ipv4"
              #gatewayInput="ngModel"
              required
              [pattern]="ipv4Pattern"
              (ngModelChange)="gatewayChange()"
            />
            <div *ngIf="isNewTestConfig" class="err-msgContainer">
              <mat-error *ngIf="gatewayInput?.errors?.required"> Required field</mat-error>
              <mat-error *ngIf="gatewayInput.errors?.pattern"> Invalid address </mat-error>
            </div>
          </div>
        </div>

        <div class="row" *ngIf="formField.ipVersion === 'v6'">
          <div class="control-group" flex="70">
            <label class="labelMode">Address *</label>
            <input
              [(ngModel)]="formField.ipAddressV6"
              name="ipV6"
              class="control input-decor width-ipv6"
              [ngClass]="{
                invalidInput: (isnotUniqueConfig || isnotUniqueIPConfig) && isNewTestConfig
              }"
              [disabled]="mgmtPortTesting"
              (ngModelChange)="isUniqueConfig(); ipaddressV6Change()"
              required
              #addressV6Input="ngModel"
              [pattern]="ipv6Pattern"
              matTooltip="This endpoint has management port testing enabled. IP address is set to the
            address of the endpoint."
              [matTooltipDisabled]="!mgmtPortTesting"
            />
            <div *ngIf="isNewTestConfig" class="err-msgContainer">
              <mat-error *ngIf="addressV6Input?.errors?.required"> Required field</mat-error>
              <mat-error *ngIf="addressV6Input?.errors?.pattern">Invalid address</mat-error>
              <mat-error *ngIf="(isnotUniqueConfig || isnotUniqueIPConfig) && isNewTestConfig"
                >Address in use by running reflector/initiator</mat-error
              >
            </div>
          </div>
          <div class="control-group" flex="28" *ngIf="!mgmtPortTesting">
            <label class="labelMode">Subnet Prefix Length *</label>
            <input
              [(ngModel)]="formField.prefixV6"
              name="prefixV6"
              class="control input-decor input-small"
              required
              #subnetV6Input="ngModel"
              [pattern]="ipv6PrefixLengthPattern"
              (ngModelChange)="prefixV6Change()"
            />
            <div *ngIf="isNewTestConfig" class="err-msgContainer">
              <mat-error *ngIf="subnetV6Input?.errors?.required"> Required field</mat-error>
              <mat-error *ngIf="subnetV6Input?.errors?.pattern"
                >Invalid subnet prefix length</mat-error
              >
            </div>
          </div>
        </div>
        <div class="row start center" *ngIf="formField.ipVersion === 'v6' && !mgmtPortTesting">
          <div class="control-group" flex="40">
            <label class="labelMode">Gateway *</label>
            <input
              [(ngModel)]="formField.gatewayV6"
              name="gatewayV6"
              class="control input-decor width-ipv6"
              required
              #gatewayV6Input="ngModel"
              [pattern]="ipv6Pattern"
              (ngModelChange)="gatewayV6Change()"
            />
            <div *ngIf="isNewTestConfig" class="err-msgContainer">
              <mat-error *ngIf="gatewayV6Input?.errors?.required"> Required field</mat-error>
              <mat-error *ngIf="gatewayV6Input?.errors?.pattern">Invalid address</mat-error>
            </div>
          </div>
        </div>
        <div class="row row-item start start" *ngIf="formField.reflectorMode !== 'light'">
          <div class="control-group" flex="35">
            <label class="labelMode">Control Port</label>
            <input
              [(ngModel)]="formField.controlPort"
              name="port"
              class="control input-decor input-ipv4"
              required
              #controlPortInput="ngModel"
              [pattern]="controlPortPattern"
              (ngModelChange)="controlPortChange()"
            />
            <div *ngIf="isNewTestConfig" class="err-msgContainer">
              <mat-error *ngIf="controlPortInput?.errors?.required"> Required field</mat-error>
              <mat-error *ngIf="controlPortInput?.errors?.pattern">Range is 1-65535</mat-error>
            </div>
          </div>
          <div class="control-group" flex="32">
            <label class="labelMode">Max Sessions *</label>
            <input
              type="number"
              [(ngModel)]="formField.maxSessions"
              name="sessions"
              class="control input-decor input-ipv4"
              [disabled]="!isNewTestConfig || agentType === 'QT600-10'"
              required
              #maxSessionInput="ngModel"
              min="1"
              [max]="sessionsConfig.maxSessions"
              (ngModelChange)="maxSessionChange()"
            />
            <div *ngIf="isNewTestConfig" class="err-msgContainer">
              <mat-error *ngIf="maxSessionInput?.errors?.required"> Required field</mat-error>
              <mat-error *ngIf="maxSessionInput?.errors?.min || maxSessionInput?.errors?.max">
                Value should be 1 to {{ sessionsConfig.maxSessions }}</mat-error
              >
            </div>
          </div>
          <div class="control-group" flex="33">
            <label class="labelMode">Max Flows *</label>
            <input
              type="number"
              [(ngModel)]="formField.maxFlows"
              name="flows"
              class="control input-decor input-ipv4"
              [disabled]="!isNewTestConfig || agentType === 'QT600-10'"
              required
              #maxFlowsInput="ngModel"
              min="1"
              [max]="flowsConfig.maxFlows"
              (ngModelChange)="maxFlowsChange()"
            />
            <div *ngIf="isNewTestConfig" class="err-msgContainer">
              <mat-error *ngIf="maxFlowsInput?.errors?.required"> Required field</mat-error>
              <mat-error *ngIf="maxFlowsInput?.errors?.min || maxFlowsInput?.errors?.max">
                Value should be 1 to {{ flowsConfig.maxFlows }}</mat-error
              >
            </div>
          </div>
          <div class="control-group" *ngIf="isAllowPersist">
            <label for="restartOnBoot" class="labelMode">Persist after Reboot</label>
            <mat-select
              #restartInput="ngModel"
              name="restartOnBoot"
              [(ngModel)]="formField.restartOnBoot"
              [disabled]="!isNewTestConfig"
              class="input-decor input-medium"
              (selectionChange)="onRebootChange($event)"
            >
              <mat-option *ngFor="let opt of rebootOptions" [value]="opt.value">{{
                opt.name
              }}</mat-option>
            </mat-select>
          </div>
        </div>
        <div class="row row-item" *ngIf="formField.reflectorMode !== 'full'">
          <div class="control-group">
            <label class="labelMode">UDP Port *</label>
            <input
              [(ngModel)]="formField.udpport"
              name="udpport"
              class="control input-decor input-ipv4"
              required
              #udpPortInput="ngModel"
              (ngModelChange)="handleReflectorLightPortRange()"
            />
            <div *ngIf="isNewTestConfig" class="err-msgContainer">
              <mat-error *ngIf="udpPortInput?.errors?.required"> Required field</mat-error>
              <mat-error *ngIf="udpPortInput?.errors?.regex">1-65535 except 5060</mat-error>
            </div>
          </div>
          <div class="control-group" *ngIf="isAllowPersist">
            <label for="restartOnBoot" class="labelMode">Persist after Reboot</label>
            <mat-select
              #restartInput="ngModel"
              name="restartOnBoot"
              [(ngModel)]="formField.restartOnBoot"
              [disabled]="!isNewTestConfig"
              class="input-decor input-medium"
              (selectionChange)="onRebootChange($event)"
            >
              <mat-option *ngFor="let opt of rebootOptions" [value]="opt.value">{{
                opt.name
              }}</mat-option>
            </mat-select>
          </div>
        </div>

        <!-- <div class="row row-item start start persist" *ngIf="isAllowPersist">
          <div class="control-group row" flex="40">
            <div class="column">
              <label class="checkcontainer">
                <input
                  type="checkbox"
                  id="onBootPersist"
                  name="restartOnBoot"
                  #restartInput="ngModel"
                  [(ngModel)]="formField.restartOnBoot"
                  [disabled]="!isNewTestConfig && (actionMsg || selctedTestID)"
                  class="ng-valid ng-dirty ng-valid-parse ng-touched ng-empty"
                  aria-invalid="false"
                />
                <span class="checkmark"></span>
              </label>
            </div>
            <div class="column">
              <label for="restartOnBoot">Persist after Reboot</label>
            </div>
          </div>
        </div> -->
      </div>
    </div>
    <div class="section-container network_container" *ngIf="!isJmepAgentType">
      <div class="label-data label">
        <span class="network_label">Network</span>
      </div>
      <div class="row row-item">
        <div class="control-group">
          <label class="labelMode">VLAN Config</label>
          <mat-select
            class="input-decor input-medium"
            #vlanConfigInput="ngModel"
            name="vlanConfigInput"
            [(ngModel)]="formField.vlanConfig"
            (ngModelChange)="onVlanConfigChange(); isUniqueConfig()"
          >
            <mat-option *ngFor="let mode of vlanConfigTypes" [value]="mode.value">
              {{ mode.name }}</mat-option
            >
          </mat-select>
        </div>
        <div class="row row-item" *ngIf="formField.vlanConfig !== 'untagged'">
          <div class="control-group">
            <label class="labelMode" *ngIf="formField.vlanConfig !== 'tagged'">S-VLAN *</label
            ><label class="labelMode" *ngIf="formField.vlanConfig === 'tagged'">VLAN *</label>
            <input
              matInput
              type="number"
              class="input-decor input-medium"
              #sVlanInput="ngModel"
              name="sVlanInput"
              [(ngModel)]="formField.svlan"
              required
              min="1"
              max="4095"
              (ngModelChange)="onSVlanChange(); isUniqueConfig()"
            />
            <span
              class="error"
              *ngIf="sVlanInput.invalid && (sVlanInput.dirty || sVlanInput.touched)"
            >
              <mat-error *ngIf="sVlanInput.errors.required">Vlan is required</mat-error>
              <mat-error *ngIf="sVlanInput.errors.min || sVlanInput.errors.max"
                >Valid range 1 and 4065</mat-error
              >
              <mat-error *ngIf="isnotUniqueConfig && isNewTestConfig"
                >IP and VLAN in use by running reflector</mat-error
              >
            </span>
          </div>
          <div class="control-group" *ngIf="formField.vlanConfig !== 'tagged'">
            <label class="labelMode">C-VLAN *</label>
            <input
              matInput
              type="number"
              class="input-decor input-medium"
              #cVlanInput="ngModel"
              name="cVlanInput"
              [(ngModel)]="formField.cvlan"
              required
              min="1"
              max="4065"
              (ngModelChange)="onCVlanChange(); isUniqueConfig()"
            />
            <div
              class="error"
              *ngIf="cVlanInput.invalid && (cVlanInput.dirty || cVlanInput.touched)"
            >
              <mat-error *ngIf="cVlanInput.errors.required">C-Vlan is required</mat-error>
              <mat-error *ngIf="cVlanInput.errors.min || cVlanInput.errors.max"
                >Valid range 1 and 4065</mat-error
              >
              <mat-error *ngIf="isnotUniqueConfig && isNewTestConfig"
                >IP and VLAN in use by running reflector</mat-error
              >
            </div>
          </div>
          <div class="control-group" *ngIf="formField.vlanConfig !== 'tagged'">
            <label class="labelMode">Ethertype</label>
            <mat-select
              class="input-decor input-medium"
              #cvlanEthertypeInput="ngModel"
              name="cvlanEthertypeInput"
              [(ngModel)]="formField.etherType"
              (ngModelChange)="onCVlanEtherTypeChange()"
            >
              <mat-option *ngFor="let ether of etherTypesData" [value]="ether.value">{{
                ether.name
              }}</mat-option>
            </mat-select>
          </div>
        </div>
      </div>
    </div>
    <div class="section-container" *ngIf="isJmepAgentType">
      <div class="label-data label"><b>Setup</b></div>
      <div class="column">
        <div class="row row-item">
          <div class="control-group">
            <label class="labelMode">Address</label>
            <input
              matInput
              autocomplete="off"
              [(ngModel)]="formField.ipAddress"
              name="ip"
              class="control input-decor input-ipv4"
              [disabled]="true"
              required
              #addressInput="ngModel"
            />
          </div>
          <div class="control-group">
            <label class="labelMode">UDP Port *</label>
            <input
              [(ngModel)]="formField.udpport"
              name="udpport"
              class="control input-decor input-ipv4"
              required
              #udpPortInput="ngModel"
              (ngModelChange)="handleReflectorLightPortRange()"
            />
            <div *ngIf="isNewTestConfig" class="err-msgContainer">
              <mat-error *ngIf="udpPortInput?.errors?.required"> Required field</mat-error>
              <mat-error *ngIf="udpPortInput?.errors?.regex">1-65535 except 5060</mat-error>
            </div>
          </div>
          <div class="control-group" *ngIf="formField.svlan">
            <label class="labelMode">Vlan</label>
            <input
              matInput
              autocomplete="off"
              [(ngModel)]="formField.svlan"
              name="vlan"
              class="control input-decor input-ipv4"
              #vlanInput="ngModel"
              [disabled]="true"
              required
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</form>
